import { ID, WoosatTelecomResponse, Response } from '../../../../../_metronic/helpers'

export type PurchasedProduct = {
  id?:any
  product_name?:string
  service_id?:any
  purchased_product_logo?:string
  supplier_id?: string         // Field for supplier ID
  supplier_name?: string       // Field for supplier name
  quantity?: number            // Field for product quantity
  purchase_price?: number      // Field for purchase price
  purchase_date?: string  
  status?:any     // Field for purchase date
}

export type PurchasedProductsQueryResponse = WoosatTelecomResponse<PurchasedProduct[]>

export const initialPurchasedProduct: PurchasedProduct = {
  id:'',
  product_name:'',
  service_id:'',
  purchased_product_logo:"",
  supplier_id: '',             // Default value for supplier ID
  supplier_name: '',           // Default value for supplier name
  quantity: 0,                 // Default value for product quantity
  purchase_price: 0,           // Default value for purchase price
  purchase_date: '',   
  status:1        // Default value for purchase date
}
